import { render, staticRenderFns } from "./SupportRequest.vue?vue&type=template&id=275dbdd2&scoped=true"
import script from "./SupportRequest.vue?vue&type=script&lang=js"
export * from "./SupportRequest.vue?vue&type=script&lang=js"
import style0 from "./SupportRequest.vue?vue&type=style&index=0&id=275dbdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275dbdd2",
  null
  
)

export default component.exports